import {
  ESdChangeReason,
  ESymbolCategory,
  IAction,
  IActionParameter,
  IScreenDesign,
  ISymbol
} from "@kuika/kuika-cl-model";
import _ from "lodash";
import { IWithSDProps, withSD } from "../../../../shared/hoc/screen-design-consumer";
import { IWithContextProp, withContext } from "../../../../shared/hoc/with-context";
import { PureSdComponent } from "../../../../shared/pure-sd";
import KuikaSelectbox, { KuikaSelectboxOption } from "../../../ui-kit/kuika-selectbox/kuika-selectbox";
import { IActionPanelStatesCanBeUpdatedFromChild } from "./action-panel";

const SUPPORTED_PAYMENT_TYPE_OPTIONS: KuikaSelectboxOption[] = [
  { key: "card", value: "card", label: "Credit Card" },
  { key: "sepa_debit", value: "sepa_debit", label: "SEPA - Direct Debit" }
];

export interface IStripePaymentIntentSymbolsGroupState {}

export interface IStripePaymentIntentSymbolsGroupProps {
  action: IAction;
  parameters: IActionParameter[];
  updateValues: (value: IActionPanelStatesCanBeUpdatedFromChild, changeReason?: ESdChangeReason) => void;
}

class StripeSetupIntentSymbolsGroup extends PureSdComponent<
  IStripePaymentIntentSymbolsGroupProps & IWithSDProps & IWithContextProp,
  IStripePaymentIntentSymbolsGroupState
> {
  constructor(props: IStripePaymentIntentSymbolsGroupProps & IWithSDProps & IWithContextProp) {
    super(props);
  }

  componentDidMount() {
    const sd: IScreenDesign = this.props.sd.getScreenDesign();
  }

  handleSelectValues = (value, parameter, changeReason?: ESdChangeReason) => {
    if (value && Array.isArray(value)) {
      value = value.toString();
    }
    const params = _.cloneDeep(this.props.parameters);
    const _parameter = parameter;
    if (!_parameter.symbol) _parameter.symbol = {} as any;
    _parameter.symbol.fixedValue = value;
    _parameter.symbol.category = ESymbolCategory.fixed;
    const valuesToUpdate = {
      actionParameters: params
    } as IActionPanelStatesCanBeUpdatedFromChild;
    valuesToUpdate.actionParameters?.push(_parameter);
    this.props.updateValues(valuesToUpdate, changeReason);
  };

  handleSelectSymbolPickerValue = (parameter: IActionParameter, symbol: ISymbol, changeReason?: ESdChangeReason) => {
    symbol.targetType = "String";
    parameter.Typename = "String";
    const params = _.cloneDeep(this.props.parameters);
    const _parameter = parameter;
    _parameter.symbol = symbol;
    const valuesToUpdate = {
      actionParameters: params
    } as IActionPanelStatesCanBeUpdatedFromChild;
    valuesToUpdate.actionParameters?.push(_parameter);
    this.props.updateValues(valuesToUpdate, changeReason);
  };

  getPaymentTypeValues(paymenttype: IActionParameter) {
    let comaSeperated = paymenttype.symbol?.fixedValue as string;
    return comaSeperated ? comaSeperated.split(",") : undefined;
  }

  renderSymbolPicker = (): JSX.Element => {
    const supportedPaymentTypes = this.props.parameters.find((element) => element.name === "supportedPaymentTypes");

    return (
      <div className="kuika_property-grid-column">
        <div className="kuika_property-grid-column">
          <span style={{ marginBottom: 6, marginTop: 8 }} className="k_Regular-G1-Left kuika_rightPanelDIName">
            Payment Types
          </span>
          <KuikaSelectbox
            mode="multiple"
            searchable
            onChange={(value: string[]): void => this.handleSelectValues(value, supportedPaymentTypes)}
            style={{ width: "100%" }}
            className="k_Regular-G1-Left"
            value={this.getPaymentTypeValues(supportedPaymentTypes!) ?? []}
            options={SUPPORTED_PAYMENT_TYPE_OPTIONS}
          />
        </div>
      </div>
    );
  };

  render() {
    return <div style={{ width: "100%" }}>{this.renderSymbolPicker()}</div>;
  }

  checkNeedRender = (changeReason: ESdChangeReason): boolean => {
    if (
      changeReason === ESdChangeReason.DiActionUpdated ||
      changeReason === ESdChangeReason.ChangeSelectedDiByCanvasFrame ||
      changeReason === ESdChangeReason.ChangeSelectedDiByTools ||
      changeReason === ESdChangeReason.DragDropDi ||
      changeReason === ESdChangeReason.DragDropBlock ||
      changeReason === ESdChangeReason.WFStepMappingChange
    ) {
      return true;
    }
    return false;
  };
}

const stripePaymentIntentSymbolsGroup = withContext<IStripePaymentIntentSymbolsGroupProps>(
  withSD<IStripePaymentIntentSymbolsGroupProps>(StripeSetupIntentSymbolsGroup)
);
export { stripePaymentIntentSymbolsGroup as StripeSetupIntentSymbolsGroup };
